// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1ZS6-","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3dxcB","obliqueLine":"membershipbadge_obliqueLine__1dw2T"};